const LOCAL_STORAGE_KEYS = {
  RETURN_TO: 'app_returnTo',
} as const

/**
 * Reads returnTo from URL query params, stores it in local storage,
 * and removes it from the URL
 */
const initializeFromQueryParams = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const returnTo = urlParams.get('returnTo')

  // Store in local storage if present
  if (returnTo) {
    if (returnTo == 'clear') {
      localStorage.clear(LOCAL_STORAGE_KEYS.RETURN_TO)
    } else {
      localStorage.setReturnTo(returnTo)
    }

    // Remove from URL
    urlParams.delete('returnTo')

    const newSearch = urlParams.toString()
    const newUrl = `${window.location.pathname}${newSearch ? `?${newSearch}` : ''}${window.location.hash}`

    window.history.replaceState({}, '', newUrl)
  }
}

export const localStorage = {
  setReturnTo: (path: string) => {
    window.localStorage.setItem(LOCAL_STORAGE_KEYS.RETURN_TO, path)
  },

  getReturnTo: (): string | null => {
    return window.localStorage.getItem(LOCAL_STORAGE_KEYS.RETURN_TO)
  },

  clear: (key?: string) => {
    if (key) {
      window.localStorage.removeItem(key)
      return
    }

    window.localStorage.removeItem(LOCAL_STORAGE_KEYS.RETURN_TO)
  },

  initializeFromQueryParams,
}
